import {
    type ApiResult,
    type BaseParams,
    type GetGroupItemsResponse,
    type GroupItemsFilterQuery,
    type GroupParam,
    links,
    Request,
} from '@app/client';
import { apiFactory } from '@app/client/apiFactory/api';

// Get all items for a group to show in a grid/tile view.
type GetGroupItemsParams = BaseParams<GroupItemsFilterQuery> & Required<GroupParam>;

// Get the items in a group. Using the Request.getRequest function.
const getGroupItems = (params: GetGroupItemsParams): Promise<ApiResult<GetGroupItemsResponse>> =>
    Request.getRequest<GetGroupItemsResponse>({
        ...params,
        target: links.pods.single(params.groupId).items(),
    });

export const GET_GROUP_ITEMS_LIMIT = 20;
// Get the items in a group using the APIClient.
// If {groupId} is not provided, a reject promise is thrown before the call.
export const callGetGroupItems = (
    params: Partial<Pick<GetGroupItemsParams, 'query' | 'groupId' | 'settings'>>,
): Promise<GetGroupItemsResponse> =>
    typeof params.groupId === 'undefined'
        ? Promise.reject(new Error('Invalid groupId'))
        : apiFactory()
              .call(getGroupItems, {
                  ...params,
                  groupId: params.groupId,
                  query: {
                      limit: GET_GROUP_ITEMS_LIMIT,
                      ...params.query,
                  },
              })
              .then((result) => {
                  if (result.ok) {
                      return result.value;
                  }
                  const errorMessage =
                      result?.error?.detail && typeof result.error.detail === 'string'
                          ? result.error.detail
                          : (result.error as string) || `Error getting group items ${params.groupId}`;
                  throw new Error(errorMessage);
              });
